import Orders from './Orders'

export default Orders



// WEBPACK FOOTER //
// ./src/features/Personal/containers/Orders/index.js